import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { AUTHORIZATION_ROLE } from './core/config/authorization-roles';

export const routes: Routes = [
    {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  // Rota de login
  {
    path: 'login',
    loadComponent: () => import('./features/auth/components/login/login.component').then(m => m.LoginComponent),
    data: { breadcrumb: 'Login' }
  },

  // Dashboard
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [authGuard, roleGuard],
    data: { breadcrumb: 'Visão Geral', roles: [AUTHORIZATION_ROLE.BACKOFFICE_ACCESS] }
  },

  // Simulador de financiamento imobiliário
  {
    path: 'simulador',
    loadComponent: () => import('./features/simulacao-financiamento/simulacao-financiamento.component')
      .then(m => m.SimulacaoFinanciamentoComponent),
    canActivate: [authGuard, roleGuard],
    data: { breadcrumb: 'Simulador de financiamento', roles: [AUTHORIZATION_ROLE.BACKOFFICE_ACCESS] }
  },

  // Parâmetros
  {
    path: 'parametros',
    loadComponent: () => import('./features/parametros/components/tab-parametros/tab-parametros.component').then(m => m.TabParametrosComponent),
    canActivate: [authGuard, roleGuard],
    data: {
      breadcrumb: 'Configurações',
      roles: [AUTHORIZATION_ROLE.PARAMETERIZATION_ACCESS]
    }
  },

  // Laboratório de Análise Documental
  {
    path: 'analise-documental/laboratorio',
    loadComponent: () => import('./features/analise-documental/pages/laboratorio-documental/laboratorio-documental.component')
      .then(m => m.LaboratorioDocumentalComponent),
    canActivate: [authGuard, roleGuard],
    data: {
      breadcrumb: 'Laboratório IA',
      roles: [AUTHORIZATION_ROLE.DOCUMENT_ANALYSIS_LAB_ACCESS, AUTHORIZATION_ROLE.BACKOFFICE_ACCESS]
    }
  },

  // Gestão de FGTS
  {
    path: 'fgts',
    loadChildren: () => import('./features/fgts/fgts.routes').then(m => m.FGTS_ROUTES),
    canActivate: [authGuard, roleGuard],
    data: { roles: [AUTHORIZATION_ROLE.BACKOFFICE_ACCESS] }
  },

  // Acesso negado
  {
    path: 'acesso-negado',
    loadComponent: () => import('./core/shared/components/acesso-negado/acesso-negado.component').then(m => m.AcessoNegadoComponent),
    data: { breadcrumb: 'Sem Acesso' }
  },
  {
    path: 'participantes',
    canActivate: [authGuard, roleGuard],
    data: { roles: [AUTHORIZATION_ROLE.BACKOFFICE_ACCESS] },
    children: [
      {
        path: '',
        loadComponent: () => import('./features/participantes/listagem-participantes/listagem-participantes.component').then(m => m.ListagemParticipantesComponent),
        data: { breadcrumb: 'Participantes' },
      },
      {
        path: 'proposta',
        loadComponent: () => import('./features/participantes/consulta-participante/components/proposta-manual-form/proposta-manual-form.component').then(m => m.PropostaManualFormComponent),
        data: { breadcrumb: 'Nova Proposta' }
      },
      {
        path: 'consulta/:matricula',
        loadComponent: () => import('./features/participantes/consulta-participante/consulta-participante.component').then(m => m.ConsultaParticipanteComponent),
        data: { breadcrumb: 'Consulta de Participante' },
        children: [
          {
            path: '',
            loadComponent: () => import('./features/participantes/consulta-participante/components/container-participante/container-participante.component').then(m => m.ContainerParticipanteComponent)
          },
          {
            path: 'fgts',
            loadComponent: () => import('./features/participantes/fgts-proposta/fgts-proposta.component').then(m => m.FgtsPropostaComponent)
          }
        ]
      }
    ]

  }
];
